import { render, staticRenderFns } from "./pages4.vue?vue&type=template&id=44c7a3a7&scoped=true&"
import script from "./pages4.vue?vue&type=script&lang=js&"
export * from "./pages4.vue?vue&type=script&lang=js&"
import style0 from "./pages4.vue?vue&type=style&index=0&id=44c7a3a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7a3a7",
  null
  
)

export default component.exports